import React, { Suspense } from 'react';
import CircularProgress from '../../../components/CircularProgress';

const FakeServiceList = React.lazy(() => import('../components/FakeServiceList'));
function FakeServiceListView(props: Object) {
  return (
    <Suspense fallback={<CircularProgress />}>
      <FakeServiceList {...props} />
    </Suspense>
  );
}

export default FakeServiceListView;
